// IMPORTS
import Vue from 'vue'
import Router from 'vue-router'
import mainComponent from '../components/mainComponent'

Vue.use(Router)

// ROUTES
const routes = [
  {
    path: '/',
    name: 'main',
    component: mainComponent
  }
]
// EXPORT ROUTER
export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_FRONTEND_PUBLIC_PATH,
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js